export default __webpack_public_path__ + "static/media/part_1_img_3.9c84005f.png";